import useContentModal from "./useContentModal";

const useCalculatorModal = () => {
  const { modalState, shouldUseModal, openContent, closeModal } =
    useContentModal("calculator");

  // Map the generic content methods to calculator-specific names for backward compatibility
  const openCalculator = (calculatorId, navigate) => {
    openContent(calculatorId, navigate);
  };

  return {
    modalState: {
      isOpen: modalState.isOpen,
      calculatorId: modalState.contentId, // Map contentId to calculatorId for backward compatibility
    },
    shouldUseModal,
    openCalculator,
    closeModal,
  };
};

export default useCalculatorModal;
